import axios from "axios";

export const getSection2 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/landing-page-s2-benefit?populate=*`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
